import { render, staticRenderFns } from "./AttendeeDetails.vue?vue&type=template&id=a324ec96&scoped=true&"
import script from "./AttendeeDetails.vue?vue&type=script&lang=js&"
export * from "./AttendeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeDetails.vue?vue&type=style&index=0&id=a324ec96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324ec96",
  null
  
)

export default component.exports